/**
 * lib/titresPages.js — titre de l'onglet pour chaque route du module MOOC.
 * Appliqué par components/SuiviPages.js.
 */

export const SUFFIXE_TITRE = 'Innovactive360';
const TITRE_MODULE = "MOOC";

const TITRES = {
  "/": "MOOC",
  "/about": "À propos - MOOC",
  "/courses": "Catalogue des cours - MOOC",
  "/course": "Cours - MOOC",
  "/learn": "Apprendre - MOOC",
  "/my-courses": "Mes cours - MOOC",
  "/dashboard": "Tableau de bord - MOOC",
  "/certificates": "Mes certificats - MOOC",
  "/evaluation": "Évaluation - MOOC",
  "/gamification": "Progression et badges - MOOC",
  "/ai-assistant": "Assistant IA - MOOC",
  "/chat": "Messagerie - MOOC",
  "/analytics": "Statistiques - MOOC",
  "/reports": "Rapports - MOOC",
  "/reviews": "Avis - MOOC",
  "/programs": "Programmes - MOOC",
  "/instructor": "Espace formateur - MOOC",
  "/instructor/create-course": "Créer un cours - MOOC",
  "/admin": "Administration - MOOC",
  "/admin/certificates": "Certificats - Administration MOOC",
  "/admin/certificate-settings": "Réglages des certificats - MOOC",
  "/users": "Utilisateurs - MOOC",
  "/coaching": "Coaching - MOOC",
  "/coaching/dashboard": "Coaching - MOOC",
  "/coaching/diagnostic": "Diagnostic - Coaching",
  "/coaching/minutes": "Comptes rendus - Coaching",
  "/coaching/plan": "Plan d'accompagnement - Coaching",
  "/documentation": "Documentation - MOOC",
  "/notifications": "Notifications - MOOC",
  "/profile": "Mon profil - MOOC",
  "/settings": "Paramètres - MOOC",
  "/subscription": "Abonnement - MOOC",
  "/verify": "Vérification - MOOC",
  "/login": "Connexion - MOOC",
  "/register": "Inscription - MOOC",
  "/privacy": "Confidentialité - MOOC",
  "/terms": "Conditions d'utilisation - MOOC",
};

/** Titre complet de l'onglet pour un chemin (préfixe le plus long), ex. « Appels à projets - Innovactive360 ». */
export function titrePourChemin(chemin) {
  let partie = chemin.replace(/\/+$/, '') || '/';
  for (;;) {
    const titre = TITRES[partie];
    if (titre) return `${titre} - ${SUFFIXE_TITRE}`;
    if (partie === '/') return `${TITRE_MODULE} - ${SUFFIXE_TITRE}`;
    const i = partie.lastIndexOf('/');
    partie = i <= 0 ? '/' : partie.slice(0, i);
  }
}
